import { tips } from "../../../stores/globalState";
export function handleMouseEnterCommon(e) {
    tips.set([
        { name: "改变数字大小", shortcut: '长按' },
        { name: "改变主题色", shortcut: '右键点击' }
    ]);
}
export function handleMouseLeaveCommon(e) {
    tips.set(null);
}
